<div class="row list-item-row border-bottom py-4" data-testing-id="product-list-item">
  <!-- Errors and Infos -->
  <div *ngIf="pli.validationError?.message" class="alert alert-inline alert-danger col-12">
    {{ pli.validationError.message }}
  </div>
  <div *ngIf="pli.info?.message" class="alert alert-inline alert-info col-12">
    {{ pli.info.message }}
  </div>
  <div class="col-10 col-md-6 col-xl-5">
    <div class="row">
      <div class="col-3 p-0 pl-1" [ngClass]="{ 'pl-0 pr-0': editable }">
        <ish-product-image imageType="M" [link]="true"></ish-product-image>
      </div>
      <div class="col-9">
        <!--Product Description -->
        <div class="pli-description">
          <ish-product-name [alternate]="pli.name"></ish-product-name>

          <!-- Product ID -->
          <ish-product-id></ish-product-id>

          <!-- Product Variations -->
          <ish-product-variation-display></ish-product-variation-display>
          <!-- Product Bundles -->
          <ish-product-bundle-display></ish-product-bundle-display>

          <!-- switch by lineItemViewType -->
          <ng-container [ngSwitch]="lineItemViewType">
            <!-- lineItemViewType = 'simple' -->
            <ng-container *ngSwitchCase="'simple'"></ng-container>

            <!-- lineItemViewType = 'availability' -->
            <ng-container *ngSwitchCase="'availability'">
              <ish-product-inventory></ish-product-inventory>
            </ng-container>

            <!-- default lineItemViewType -->
            <ng-container *ngSwitchDefault>
              <!-- edit variation & quantity -->
              <ng-container *ngIf="editable">
                <ish-line-item-edit
                  *ngIf="!('preferences.ChannelPreferences.EnableAdvancedVariationHandling' | ishServerSetting)"
                  ishProductContext
                  [sku]="pli.productSKU"
                  [quantity]="pli.quantity.value"
                  [itemId]="pli.id"
                  (updateItem)="onUpdateItem($event)"
                ></ish-line-item-edit>
              </ng-container>

              <!-- availability -->
              <ish-product-inventory></ish-product-inventory>

              <!-- ship window message -->
              <ish-product-shipment></ish-product-shipment>

              <!-- surcharges -->
              <div *ngFor="let surcharge of pli.itemSurcharges">
                {{ surcharge.displayName }} <span *ngIf="!surcharge.displayName">{{ surcharge.text }}</span>
                <span class="text-nowrap"> {{ surcharge.amount | ishPrice }} </span>
                <ng-template #SurchargeDescription> <span [innerHTML]="surcharge.description"></span> </ng-template>
                <a
                  class="btn btn-link details-tooltip"
                  [ngbPopover]="SurchargeDescription"
                  [popoverTitle]="surcharge.displayName"
                  placement="top"
                >
                  {{ 'shopping_cart.detail.text' | translate }}
                  <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
                </a>
              </div>
            </ng-container>
          </ng-container>

          <!-- promotions -->
          <div *ngIf="pli.valueRebates?.length">
            <ng-container *ngFor="let rebate of pli.valueRebates">
              <ish-basket-promotion [rebate]="rebate" class="list-item-promo"></ish-basket-promotion>
            </ng-container>
          </div>
          <div class="d-flex mt-3 save-for-later">
            <div class="shopping-cart-icon">
              <ish-lazy-product-add-to-order-template
                *ngIf="editable"
                [cssClass]="'btn-link btn-tool pl-0 add-to-order-template'"
                displayType="icon"
              >
              </ish-lazy-product-add-to-order-template>
              <ish-lazy-product-add-to-wishlist
                *ngIf="editable"
                [cssClass]="'btn-link btn-tool pl-0 add-to-wishlist'"
                displayType="icon"
              >
              </ish-lazy-product-add-to-wishlist>
            </div>

            <custom-lazy-product-add-to-save-for-later
              *ngIf="editable"
              [basketLineItemId]="pli.id"
            ></custom-lazy-product-add-to-save-for-later>
            <!-- <a
            class="btn-tool"
            *ngIf="!pli.isFreeGift && editable"
            [attr.data-testing-id]="'remove-line-item'"
            [attr.data-id]="pli.id"
            title="{{ 'shopping_cart.remove.item.button.label' | translate }}"
            (click)="onDeleteItem(pli.id)"
          >
            <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
          </a> -->
          </div>
        </div>

        <!-- mobile quantity -->

        <div class="d-md-none mb-2">
          <span>{{ 'shopping_cart.price.heading' | translate }} : </span>
          <span> {{ pli.singleBasePrice | ishPrice }}</span>
        </div>

        <div class="quantity quantity-input-container d-xl-none">
          <div class="form-group">
            <span>
              <ish-product-quantity-label
                translationKey="shopping_cart.pli.qty.label"
                [for]="'pli-quantity_' + pli.position"
                class="col-form-label"
              ></ish-product-quantity-label>
              <ish-product-quantity
                *ngIf="editable; else readonly"
                [elementId]="'pli-quantity_' + pli.position"
              ></ish-product-quantity>

              <ng-template #readonly class="quantitynumber">{{ pli.quantity.value | number }}</ng-template>
            </span>
          </div>
        </div>
        <div class="d-md-none">
          <!-- (Suggested) Total Price  -->
          <span> {{ 'shopping_cart.subtotal.dias.heading' | translate }} :</span>
          <span data-testing-id="total-price"> {{ pli.totals.total | ishPrice }}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Product Image -->

  <!-- Prices -->
  <div class="col-md-3 d-none d-md-block pricing-container">
    <!-- (Suggested) Single Base Price  -->
    <div>
      {{ pli.singleBasePrice | ishPrice }}
    </div>
    <!-- Undiscounted single price -->
    <div *ngIf="oldPrice" class="old-price">
      <span class="price-value">{{ oldPrice | ishPrice }}</span>
    </div>
  </div>

  <!-- desktop quantity -->
  <div class="col-2 col-xl-1 d-none d-xl-flex">
    <div class="form-group w-100 text-right" [ngClass]="{ 'pr-2': !editable }">
      <label class="d-xl-none col-form-label">{{ 'shopping_cart.pli.qty.label' | translate }}</label>

      <ish-product-quantity
        *ngIf="editable; else readonly"
        [elementId]="'pli-quantity_' + pli.position"
      ></ish-product-quantity>
      <ng-template #readonly>{{ pli.quantity.value | number }}</ng-template>
    </div>
  </div>
  <div *ngIf="pli.totals" class="col-3 col-md-2 total-price-display">
    <div>
      <!-- (Suggested) Total Price  -->
      <div data-testing-id="total-price">{{ pli.totals.total | ishPrice }}</div>
    </div>

    <!-- Value Rebates Total -->
    <div *ngIf="pli.totals.valueRebatesTotal" class="old-price">
      <span class="price-value">{{ pli.totals.undiscountedTotal | ishPrice }}</span>
    </div>

    <!-- Gift -->
    <div *ngIf="pli.isFreeGift" class="list-item-promo">{{ 'checkout.pli.freegift.text' | translate }}</div>
  </div>

  <!-- Action tab -->
  <div
    *ngIf="!pli.isFreeGift && editable"
    class="col-2 col-md-2 col-xl-1 text-right shopping-cart-action"
    [ngClass]="{ 'pr-0': editable }"
  >
    <span>
      <custom-edit-line-item [pli]="pli" [icon]="['fas', 'pencil']"></custom-edit-line-item>
    </span>
    <span>
      <a
        *ngIf="!pli.isFreeGift && editable"
        [attr.data-testing-id]="'remove-line-item'"
        [attr.data-id]="pli.id"
        title="{{ 'shopping_cart.remove.item.button.label' | translate }}"
        (click)="onDeleteItem(pli.id)"
        data-inline="true"
      >
        X
      </a></span
    >
  </div>
  <!-- display/select warranty if available -->
  <div class="col-sm-12">
    <ish-line-item-warranty [pli]="pli" [editable]="editable" />
  </div>
</div>
